var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.color ? 'not-fill' : 'fill'},[_c('svg',{attrs:{"width":"100","height":"10","viewBox":"0 0 100 10","fill":_vm.color,"xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"100","height":"10","rx":"5","ry":"5","fill":_vm.color}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100de9a5","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/svg/components/ArrowL.vue
// module id = FAoz
// module chunks = 0